/*
 * -----------------------------------------------------------------------
 *  <copyright file="audit-log/types/report.tsx" company="Triumph Research Intelligence">
 *      Copyright (C) 2019 by Triumph Research Intelligence. All rights reserved.
 *  </copyright>
 * -----------------------------------------------------------------------
 */

import React from 'react';
import { FieldChangeGrid } from 'views/pages/admin/audit-log/change-grid';
import AuditEnumValues from 'views/pages/admin/audit-log/definitions/enums';
import {
    getProcessedFieldChangeItems,
    getFieldChangeItems,
    removePropertiesFromObject,
} from 'views/pages/admin/audit-log/service';

const propArray = [
    'Description',
    'FileName',
    'BlobName',
    'BlobPath',
    'FileType',
    'DatasetId',
    'ComparisonDatasetId',
    'StudyId',
];

const ReportRecordChangeGrid = ({ oldRecord, newRecord, oldItem, newItem }: any) => {
    const refactoredOldRecord = {
        ...oldRecord,
        ...('Description' in oldRecord ? { Comments: oldRecord?.Description } : {}),
        ...removePropertiesFromObject(oldRecord, propArray),
    };
    const refactoredNewRecord = {
        ...newRecord,
        ...('Description' in newRecord ? { Comments: newRecord?.Description } : {}),
        ...removePropertiesFromObject(newRecord, propArray),
    };

    const arrayOfObjects = {
        Signatories: {
            valueResolver: (recordData: object) => {
                return Object.entries(recordData)
                    .map(([property, value]) => {
                        if (property.toLowerCase().match('role')) {
                            const role = AuditEnumValues.ReportSignatoryRole[value];
                            return `${property}: ${role ?? '--'}; `;
                        }
                        return `${property}: ${value ?? '--'}; `;
                    })
                    .join('');
            },
        },
    };

    const enums: any = {
        Status: AuditEnumValues.ReportStatus,
    };

    const items = getFieldChangeItems(refactoredOldRecord, refactoredNewRecord, null, (field: string) =>
        getProcessedFieldChangeItems({
            oldRecord: refactoredOldRecord,
            newRecord: refactoredNewRecord,
            oldItem,
            newItem,
            field,
            enums,
            arrayOfObjects,
            compareArrayOfObjectsFields: ['Signatories'],
        }),
    );

    return <FieldChangeGrid items={items} />;
};

export { ReportRecordChangeGrid };
